import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';

import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SharedService} from './shared.service';

import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteInterceptor } from './http-interceptor.service';

import { MatButtonModule } from  '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTableModule} from '@angular/material/table';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { MatTabsModule } from '@angular/material/tabs';
import { TextFieldModule } from '@angular/cdk/text-field';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ChartsModule } from 'ng2-charts';

import { LoginComponent } from './login/login.component';
import { CompanySelectComponent } from './login/company-select/company-select.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PartnersComponent } from './dashboard/partners/partners.component';
import { UserComponent } from './dashboard/user/user.component';
import { UsersmenuComponent } from './dashboard/usersmenu/usersmenu.component';
import { NewreceptionComponent } from './dashboard/newreception/newreception.component';
import { ReceptionsComponent } from './dashboard/receptions/receptions.component';
import { MycompanyComponent, BottomSheetOverviewExampleSheet } from './dashboard/mycompany/mycompany.component';
import { NewinvoiceComponent } from './dashboard/newinvoice/newinvoice.component';
import { InvoicesComponent } from './dashboard/invoices/invoices.component';
import { SpendingsComponent } from './dashboard/spendings/spendings.component';
import { StockBalanceComponent } from './dashboard/stock-balance/stock-balance.component';
import { CashcollectionsComponent } from './dashboard/cashcollections/cashcollections.component';
import { MatFileUploadModule } from 'angular-material-fileupload';
import { PaymentsComponent } from './dashboard/payments/payments.component';
import { NewpurchasecontractComponent } from './dashboard/newpurchasecontract/newpurchasecontract.component';
import { PurchasecontractsComponent } from './dashboard/purchasecontracts/purchasecontracts.component';
import { StatsComponent } from './dashboard/stats/stats.component';
import { TaxationsettingsComponent } from './dashboard/taxationsettings/taxationsettings.component';
import { TaxationreportComponent } from './dashboard/taxationreport/taxationreport.component';
import { AddnewcompanyComponent } from './dashboard/addnewcompany/addnewcompany.component';
import { ExternalComponent } from './external/external.component';
import { InvoiceComponent } from './external/invoice/invoice.component';
import { ProductsComponent } from './dashboard/products/products.component';
import { DocumentComponent } from './dashboard/document/document.component';
import { ApisettingsComponent } from './dashboard/apisettings/apisettings.component';
import { ActivitylogComponent } from './dashboard/activitylog/activitylog.component';
import { ManagementComponent } from './management/management.component';
import { MysettingsComponent } from './management/mysettings/mysettings.component';
import { AppsettingsComponent } from './management/appsettings/appsettings.component';
import { TasksComponent } from './management/tasks/tasks.component';
import { NewtaskComponent } from './management/newtask/newtask.component';
import { ProductsinformationComponent } from './management/productsinformation/productsinformation.component';
import { ConfigurationsComponent } from './management/configurations/configurations.component';
import { PartnersdataComponent } from './management/partnersdata/partnersdata.component';
import { ForgotpasswordComponent } from './external/forgotpassword/forgotpassword.component';
import { ProductsdataimportComponent } from './management/productsdataimport/productsdataimport.component';
import { PasswordrecoveryComponent } from './login/passwordrecovery/passwordrecovery.component';
import {MatSliderModule} from '@angular/material/slider';
import { MFAComponent } from './login/mfa/mfa.component';
import { StockComponent } from './management/stock/stock.component';
import { B2bComponent } from './b2b/b2b.component';
import { HomeComponent } from './b2b/home/home.component';
import { ProfileComponent } from './b2b/profile/profile.component';
import { TrackShippingLabelComponent } from './management/track-shipping-label/track-shipping-label.component';
import { CreateShippingLabelComponent } from './management/create-shipping-label/create-shipping-label.component';
import { CartComponent } from './b2b/cart/cart.component';
import { ListpricesComponent } from './b2b/listprices/listprices.component';
import { OfferRequestConfirmationComponent } from './b2b/offer-request-confirmation/offer-request-confirmation.component';
import { MyOfferRequestsComponent } from './b2b/my-offer-requests/my-offer-requests.component';
import { MyOrdersComponent } from './b2b/my-orders/my-orders.component';
import { MyInvoicesComponent } from './b2b/my-invoices/my-invoices.component';
import { OfferRequestsComponent } from './management/offer-requests/offer-requests.component';
import { ShipmentsComponent } from './management/shipments/shipments.component';
import { NeworderconfirmationComponent } from './management/neworderconfirmation/neworderconfirmation.component';
import { ProductspricecontrolComponent } from './management/productspricecontrol/productspricecontrol.component';
import { ErrorComponent } from './b2b/error/error.component';
import { ListpricesspreadsheetComponent } from './b2b/listpricesspreadsheet/listpricesspreadsheet.component';

import { SpreadsheetModule } from '@syncfusion/ej2-angular-spreadsheet';
import { TransportersComponent } from './dashboard/transporters/transporters.component';
import { EFacturaReceivedInvoicesComponent } from './dashboard/efactura-received-invoices/efactura-received-invoices.component';
import { RegisterComponent } from './login/register/register.component';
import { UpcomingPaymentsComponent } from './dashboard/upcoming-payments/upcoming-payments.component';
import { UpcomingCashCollectionsComponent } from './dashboard/upcoming-cash-collections/upcoming-cash-collections.component';
import { ListPricesAgGridComponent } from './b2b/list-prices-ag-grid/list-prices-ag-grid.component';
import { AgGridModule } from 'ag-grid-angular';
import { B2btrackingComponent, EventLinesToGridRowsPipe } from './management/b2btracking/b2btracking.component';
import { PartnersTransitItemsComponent } from './management/partners-transit-items/partners-transit-items.component';
import { CreateNewQuotationComponent } from './management/create-new-quotation/create-new-quotation.component';
import { OffersComponent } from './management/offers/offers.component';
import { OrderConfirmationsComponent } from './management/order-confirmations/order-confirmations.component';
import { PurchaseOrdersComponent } from './management/purchase-orders/purchase-orders.component';
import { AcceptOfferComponent } from './b2b/accept-offer/accept-offer.component';
import { OfferRequestsIndividualItemsComponent } from './management/offer-requests-individual-items/offer-requests-individual-items.component';
import { RequestedIndividualItemsComponent } from './b2b/requested-individual-items/requested-individual-items.component';
import { ClaimComponent } from './b2b/claim/claim.component';
import { ClaimsComponent } from './management/claims/claims.component';
import { ClientclaimComponent } from './external/clientclaim/clientclaim.component';
import { ProductsSpecialPricesComponent } from './management/products-special-prices/products-special-prices.component';
import { ShippingCompaniesComponent } from './shipping-companies/shipping-companies.component';
import { CarriersComponent } from './management/carriers/carriers.component';
import { PartnerComponent } from './external/partner/partner.component';
import { UsersComponent } from './management/users/users.component';
import { OrderConfirmationNewComponent } from './management/order-confirmation-new/order-confirmation-new.component';
import { NewPurchaseOrderComponent } from './management/new-purchase-order/new-purchase-order.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CompanySelectComponent,
    DashboardComponent,
    PartnersComponent,
    UserComponent,
    UsersmenuComponent,
    NewreceptionComponent,
    ReceptionsComponent,
    MycompanyComponent,
    BottomSheetOverviewExampleSheet,
    NewinvoiceComponent,
    InvoicesComponent,
    SpendingsComponent,
    StockBalanceComponent,
    CashcollectionsComponent,
    PaymentsComponent,
    NewpurchasecontractComponent,
    PurchasecontractsComponent,
    StatsComponent,
    TaxationsettingsComponent,
    TaxationreportComponent,
    AddnewcompanyComponent,
    ExternalComponent,
    InvoiceComponent,
    ProductsComponent,
    DocumentComponent,
    ApisettingsComponent,
    ActivitylogComponent,
    ManagementComponent,
    MysettingsComponent,
    AppsettingsComponent,
    TasksComponent,
    NewtaskComponent,
    ProductsinformationComponent,
    ConfigurationsComponent,
    PartnersdataComponent,
    ForgotpasswordComponent,
    ProductsdataimportComponent,
    PasswordrecoveryComponent,
    MFAComponent,
    StockComponent,
    B2bComponent,
    HomeComponent,
    ProfileComponent,
    TrackShippingLabelComponent,
    CreateShippingLabelComponent,
    CartComponent,
    ListpricesComponent,
    OfferRequestConfirmationComponent,
    MyOfferRequestsComponent,
    MyOrdersComponent,
    MyInvoicesComponent,
    OfferRequestsComponent,
    ShipmentsComponent,
    NeworderconfirmationComponent,
    ProductspricecontrolComponent,
    ErrorComponent,
    ListpricesspreadsheetComponent,
    TransportersComponent,
    EFacturaReceivedInvoicesComponent,
    RegisterComponent,
    UpcomingPaymentsComponent,
    UpcomingCashCollectionsComponent,
    ListPricesAgGridComponent,
    B2btrackingComponent,
    EventLinesToGridRowsPipe,
    PartnersTransitItemsComponent,
    CreateNewQuotationComponent,
    OffersComponent,
    OrderConfirmationsComponent,
    PurchaseOrdersComponent,
    AcceptOfferComponent,
    OfferRequestsIndividualItemsComponent,
    RequestedIndividualItemsComponent,
    ClaimComponent,
    ClaimsComponent,
    ClientclaimComponent,
    ProductsSpecialPricesComponent,
    ShippingCompaniesComponent,
    CarriersComponent,
    PartnerComponent,
    UsersComponent,
    OrderConfirmationNewComponent,
    NewPurchaseOrderComponent,
  ],
  imports: [
    BrowserModule,
    SpreadsheetModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatTableModule,
    MatSnackBarModule,
    MatPaginatorModule,
    MatCardModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatTabsModule,
    MatBottomSheetModule,
    MatFileUploadModule,
    ChartsModule,
    MatSliderModule,
    TextFieldModule,
    DragDropModule,
    AgGridModule.withComponents([]),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
  })
  ],
  providers: [
    SharedService,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RouteInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
